import {
  container,
  grayColor,
  whiteColor,
  headerHeight,
} from "assets/jss/index.js";

const navbarStyle = theme => ({
  appBar: {
    backgroundColor: whiteColor,
    borderBottom: "0",
    marginBottom: "0",
    width: "100%",
    zIndex: "100",
    color: grayColor[1],
    border: "0",
    padding: "0",
    transition: "all 150ms ease 0s",
    minHeight: headerHeight,
    boxShadow: "0 2px 2px 0 rgba(60,75,100,.14), 0 3px 1px -2px rgba(60,75,100,.12), 0 1px 5px 0 rgba(60,75,100,.2)",
    position: "fixed",
  },
  flexBox: {
    display: "flex",
    alignItems: "center",
  },
  toolBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: headerHeight,
  },
  container: {
    ...container,
  },
  menuIcon: {
    marginLeft: "-10px",
    marginRight: "10px"
  },
  flex: {
    flex: 1
  },
  logout: {
    padding: "0 12px",
    lineHeignt: "34px",
    height: "34px",
    marginLeft: "15px"
  },
  small: {
    width: "32px",
    height: "32px",
  },
  profileName: {
    margin: "0 8px",
    fontSize: "12px",
    lineHeight: "18px",

    [theme.breakpoints.down("sm")]: {
      display: "none"
    },
  },
  name: {
    fontWeight: "bold",
    fontSize: "16px",
  },
  link: {
    "& h5": {
      fontWeight: "bold",
      color: grayColor[1] + " !important",
    }
  }
});

export default navbarStyle;
